// extracted by mini-css-extract-plugin
module.exports = {"root":"FormRegistryList_root_21ki9","filter":"FormRegistryList_filter_WbXo0","timeline":"FormRegistryList_timeline_1uIzt","progress":"FormRegistryList_progress_1kwUi"};